var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 16,
    viewBox: "0 0 35 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7071 8.76131C35.0976 8.37078 35.0976 7.73762 34.7071 7.34709L28.3431 0.983131C27.9526 0.592607 27.3195 0.592607 26.9289 0.983131C26.5384 1.37366 26.5384 2.00682 26.9289 2.39735L32.5858 8.0542L26.9289 13.7111C26.5384 14.1016 26.5384 14.7347 26.9289 15.1253C27.3195 15.5158 27.9526 15.5158 28.3431 15.1253L34.7071 8.76131ZM0 9.0542H34V7.0542H0V9.0542Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1996261226e36c569e82a7e1d5f737f3.svg";
export { ForwardRef as ReactComponent };